/*
 * React Bits SpotlightCard, src/ts-default/Components/SpotlightCard/SpotlightCard.tsx
 * Source: https://github.com/DavidHDev/react-bits, commit e1bbb696fc53f7f91e694c529e4d68c899773b6e.
 * Licence: MIT + Commons Clause; see ../LICENSE.md. Use inside this product only.
 * Local patches (refine-portal-dashboards-and-spotlight-cards): HTML div attributes;
 * pointer events with fine-pointer/reduced-motion/forced-colors gates; one coalesced
 * animation frame; preference, pointer and frame cleanup. No React state or idle loop.
 */
'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import './SpotlightCard.css';
const SpotlightCard = ({ children, className = '', spotlightColor = 'rgba(255, 255, 255, 0.25)', ...props }) => {
    const divRef = useRef(null);
    useEffect(() => {
        const element = divRef.current;
        if (!element || typeof window.matchMedia !== 'function')
            return;
        const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const forced = window.matchMedia('(forced-colors: active)');
        const permitted = () => fine.matches && !reduced.matches && !forced.matches;
        let frame;
        let x = 0;
        let y = 0;
        element.style.setProperty('--spotlight-color', spotlightColor);
        const clear = () => {
            if (frame !== undefined)
                window.cancelAnimationFrame(frame);
            frame = undefined;
            element.removeAttribute('data-spotlight-active');
        };
        const move = (event) => {
            if (event.pointerType === 'touch' || !permitted()) {
                clear();
                return;
            }
            x = event.clientX;
            y = event.clientY;
            if (frame !== undefined)
                return;
            frame = window.requestAnimationFrame(() => {
                frame = undefined;
                if (!permitted()) {
                    clear();
                    return;
                }
                const rect = element.getBoundingClientRect();
                element.style.setProperty('--mouse-x', `${x - rect.left}px`);
                element.style.setProperty('--mouse-y', `${y - rect.top}px`);
                element.setAttribute('data-spotlight-active', 'true');
            });
        };
        element.addEventListener('pointermove', move, { passive: true });
        element.addEventListener('pointerleave', clear);
        element.addEventListener('pointercancel', clear);
        fine.addEventListener('change', clear);
        reduced.addEventListener('change', clear);
        forced.addEventListener('change', clear);
        return () => {
            clear();
            element.removeEventListener('pointermove', move);
            element.removeEventListener('pointerleave', clear);
            element.removeEventListener('pointercancel', clear);
            fine.removeEventListener('change', clear);
            reduced.removeEventListener('change', clear);
            forced.removeEventListener('change', clear);
        };
    }, [spotlightColor]);
    return _jsx("div", { ...props, ref: divRef, className: `card-spotlight ${className}`, children: children });
};
export default SpotlightCard;
